// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {
  fetchOrderData,
  selectSlot,
  openProduct,
  closeProduct,
  selectImage,
  toggleRoom,
  setPage,
  showAll,
  clear,
  createOrderRow,
  updateOrderRow,
  removeOrderRow,
  updateOrderRows,
  toggleMenu,
  toggleHelp,
  sendEmail,
  selectAdvanced,
  selectAdditional,
  clearOrderRows,
  toggleRoomPrice,
  toggleAdditionalPrice,
  togglePrices,
} from '../../actions/customerOrderView';
import HelpForm from '../../components/HelpForm/HelpForm';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import CustomerProductList from '../../components/CustomerProductList/CustomerProductList';
import CustomerCustomProductList from '../../components/CustomerCustomProductList/CustomerCustomProductList';
import CoverImage from '../../components/CoverImage/CoverImage';
import CustomerProductSlotList from '../../components/CustomerProductSlotList/CustomerProductSlotList';
import CustomerProductDialog from '../../components/CustomerProductDialog/CustomerProductDialog';
import CustomerOrderPrice from '../../components/CustomerOrderPrice/CustomerOrderPrice';

import ActionConfirmation from '../../containers/ActionConfirmation/ActionConfirmation';
import {NEW, COMPLETED, CONFIRMED} from '../../orderStates.js';
import {CUSTOMER, DEMO} from '../../roles.js';
import WarningText from '../../components/WarningText/WarningText';
import './CustomerOrderContainer.css';
import type {State_ as CustomerOrderViewState} from '../../reducers/customerOrderView';
import scrollToAnchor from '../../helpers/scrollHelper';
import DemoInfoBox from '../../components/DemoInfoBox/DemoInfoBox';

export type Props = {
  project: Object,
  apartment: Object,
  order: Object,
  rooms: any[],
  roomsIsFetching: boolean,
  activeSelection: any,
  products: any[],
  productsIsFetching: boolean,
  showMenu: boolean,
  activeProduct?: any,
  activeVariant?: any,
  activeImage?: any,
  showActiveProduct: boolean,
  expanedRooms: Object,
  pagination: Object,
  orderRowBySlotId: Object,
  orderRowIsFetching: boolean,
  customRows: any[],
  roomPrices: any[],
  additionalTotalPrice: {
    open: boolean,
    price: number,
  },
  totalPrice: number,
  discount: number,
  selectSlot: typeof selectSlot,
  openProduct: typeof openProduct,
  closeProduct: typeof closeProduct,
  selectImage: typeof selectImage,
  toggleRoom: typeof toggleRoom,
  setPage: typeof setPage,
  showAll: typeof showAll,
  toggleMenu: typeof toggleMenu,
  updateOrderRow: typeof updateOrderRow,
  createOrderRow: typeof createOrderRow,
  removeOrderRow: typeof removeOrderRow,
  updateOrderRows: typeof updateOrderRows,
  clearOrderRows: typeof clearOrderRows,
  fetchOrderData: typeof fetchOrderData,
  clear: typeof clear,
  updateOrder: (number, any) => void,
  userRole: number,
  orderComplete: boolean,
  showHeader?: boolean,
  sendEmail: typeof sendEmail,
  showHelp: boolean,
  toggleHelp: typeof toggleHelp,
  selectAdvanced: typeof selectAdvanced,
  selectAdditional: typeof selectAdditional,
  toggleRoomPrice: typeof toggleRoomPrice,
  toggleAdditionalPrice: typeof toggleAdditionalPrice,
  togglePrices: typeof togglePrices,
  pricesExpanded: boolean,
};

class CustomerOrderContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    const {
      apartment,
      order,
      fetchOrderData,
    } = this.props;

    if (apartment && order) {
      fetchOrderData(order, apartment);
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  getRoomCoverImage(roomTypeId) {
    const {project} = this.props;
    return _.find({roomTypeId}, project.images);
  }

  orderVariant(slot, variant) {
    const {
      order,
      orderRowBySlotId,
      updateOrderRow,
      createOrderRow,
      activeSelection,
    } = this.props;

    let existingRow, existingConfig;
    if (!!slot.advanced && !!activeSelection.config) {
      existingRow = _.find(r =>
        r.productSlotId === slot.id
        && _.some({id: r.configId}, activeSelection.config.configs)
        , orderRowBySlotId
      );
      existingConfig = _.find({
        parentId: !!activeSelection.parentConfig
          ? activeSelection.parentConfig.id
          : null,
        productVariantId: variant.id,
      }, activeSelection.config.configs);
    } else if (!slot.advanced) {
      existingRow = orderRowBySlotId[`${slot.id}__`];
    }
    if (existingRow && existingRow.productVariantId === variant.id) {
      return;
    }

    if (existingRow) {
      updateOrderRow(existingRow, slot, variant, existingConfig, activeSelection.parentConfig);
    } else {
      createOrderRow(order.id, slot, variant, existingConfig, activeSelection.parentConfig);
    }
  }

  render() {
    const {
      sendEmail,
      showHelp,
      toggleHelp,
      productsIsFetching,
      activeSelection,
      products,
      activeProduct,
      activeVariant,
      activeImage,
      showActiveProduct,
      openProduct,
      closeProduct,
      selectImage,
      toggleRoom,
      expanedRooms,
      pagination,
      setPage,
      showAll,
      orderRowBySlotId,
      showMenu,
      toggleMenu,
      roomPrices,
      additionalTotalPrice,
      totalPrice,
      discount,
      orderRowIsFetching,
      customRows,
      rooms,
      roomsIsFetching,
      removeOrderRow,
      updateOrderRows,
      updateOrder,
      order,
      userRole,
      orderComplete,
      showHeader = true,
      selectAdvanced,
      selectSlot,
      selectAdditional,
      clearOrderRows,
      toggleRoomPrice,
      toggleAdditionalPrice,
      togglePrices,
      pricesExpanded,
    } = this.props;
    return (
      <div
        id="scroll-anchor"
        className="CustomerOrderContainer">
        <div className="w-100 f-14">
          {userRole === DEMO &&
                    <DemoInfoBox />
          }
        </div>
        {showHeader &&
          <div className="page-header">
            {order.state !== NEW &&
              <div className="callout warning text-center">
                <div>Den här ordern är låst av inredningsansvarig</div>
              </div>
            }
            {order.state === NEW && !!orderComplete && userRole === CUSTOMER &&
              <div className="callout success text-center">
                <h4>Strålande, du har nu gjort ett komplett urval!</h4>
                Ändringar är möjliga fram tills inredningsansvarig låser beställningen.
              </div>
            }
            <div className="page-title">
              <div
                className="toggle-menu show-for-small-only"
                onClick={() => toggleMenu(!showMenu)}>
                <i className="fa fa-bars" />
              </div>
              {activeSelection.room && activeSelection.slot &&
                <span>{activeSelection.room.name} - {activeSelection.slot.name}</span>
              }

              {!activeSelection.room &&
                <span>Mina tillval</span>
              }
              {!!rooms.length &&
                <CustomerOrderPrice
                  discount={discount}
                  additionalTotalPrice={additionalTotalPrice}
                  roomPrices={roomPrices}
                  totalPrice={totalPrice}
                  toggleRoomPrice={toggleRoomPrice}
                  toggleAdditionalPrice={toggleAdditionalPrice}
                  togglePrices={togglePrices}
                  expanded={pricesExpanded}
                  customRows={customRows}
                  userRole={userRole} />
              }
            </div>
          </div>
        }
        <div className="row">
          <div className={classNames({
            'room-menu-container column shrink': true,
            'hide-for-small-only': !showMenu,
          })}>
            {!!rooms.length &&
              <CustomerProductSlotList
                rooms={rooms}
                expanedRooms={expanedRooms}
                orderRowBySlotId={orderRowBySlotId}
                onRoomClick={roomId => toggleRoom(roomId, !expanedRooms[roomId])}
                onSlotClick={(room, slot) => {
                  scrollToAnchor('scroll-anchor');
                  selectSlot(order.id, room, slot);
                }}
                onAdvancedClick={(room, slot, productType) => {
                  scrollToAnchor('scroll-anchor');
                  selectAdvanced(room, slot, productType);
                }}
                activeSelection={activeSelection} />
            }
            {!!customRows.length &&
              <div>
                <div
                  onClick={() => {
                    scrollToAnchor('scroll-anchor');
                    selectAdditional();
                  }}
                  className={classNames({
                    'additional-choices': true,
                    'active': activeSelection.additional,
                  })}>
                  <div className="additional-choices-check"><i className="fa fa-check-square"/></div>
                  <div className="additional-choices-title">Extra tillvalsprodukter</div>
                </div>
              </div>
            }
            {!!orderComplete && userRole === CUSTOMER &&
              <div className="order-complete">
                Nu har du gjort ett komplett urval. Ändringar är möjliga fram tills inredningsansvarig låser beställningen.
              </div>
            }
            { userRole !== DEMO &&
              <div>
                {!orderComplete && userRole !== CUSTOMER &&
                <ActionConfirmation
                  id="fillStandard"
                  className="expanded warning column shrink"
                  message="Vill du verkligen fylla resterande produktplatser med standardval?"
                  buttonText="Fyll med standardval"
                  action={() => updateOrderRows(order.id, {standard: true})} />
                }
                {userRole !== CUSTOMER && order.state === NEW && !_.isEmpty(orderRowBySlotId) &&
                <ActionConfirmation
                  id="clearRows"
                  className="expanded warning column shrink"
                  message="Vill du verkligen rensa alla val som redan gjorts?"
                  buttonText="Rensa alla val"
                  action={() => clearOrderRows(order.id)} />
                }
                {userRole !== CUSTOMER && order.state === NEW &&
                <ActionConfirmation
                  id="lockOrder"
                  className="expanded success column shrink"
                  message="Vill du verkligen låsa beställningen?"
                  buttonText="Lås beställning"
                  action={() => updateOrder(order.id, COMPLETED)}
                  disabled={!orderComplete} />
                }
                {userRole !== CUSTOMER && order.state === COMPLETED &&
                <ActionConfirmation
                  id="unlockOrder"
                  className="expanded alert column shrink"
                  message="Vill du verkligen låsa upp beställningen?"
                  buttonText="Lås upp beställning"
                  action={() => updateOrder(order.id, NEW)} />
                }
                {userRole !== CUSTOMER && order.state === COMPLETED &&
                <ActionConfirmation
                  id="confirmPurchase"
                  className="expanded success column shrink"
                  messages={[
                    'Är de aktuella plan- och köksritningarna kopplade?',
                    'Vill du verkligen bekräfta beställningen för inköp?',
                  ]}
                  buttonText="Bekräfta för inköp"
                  action={() => updateOrder(order.id, CONFIRMED)} />
                }
                {userRole !== CUSTOMER && order.state === CONFIRMED &&
                <ActionConfirmation
                  id="cancelPurchase"
                  className="expanded alert column shrink"
                  message="Vill du verkligen avbryta beställningen för inköp?"
                  buttonText="Avbryt för inköp"
                  action={() => updateOrder(order.id, COMPLETED)} />
                }
                {userRole === CUSTOMER &&
                <button
                  onClick={() => toggleHelp(true)}
                  className="button expanded secondary column shrink">
                  Kontakta säljare
                </button>
                }
                <WarningText />
              </div>
            }
          </div>
          <div className="column right-col">
            {!showHeader && !!rooms.length &&
              <CustomerOrderPrice
                discount={discount}
                additionalTotalPrice={additionalTotalPrice}
                roomPrices={roomPrices}
                totalPrice={totalPrice}
                toggleRoomPrice={toggleRoomPrice}
                toggleAdditionalPrice={toggleAdditionalPrice}
                togglePrices={togglePrices}
                expanded={pricesExpanded}
                customRows={customRows}
                userRole={userRole} />
            }
            {activeSelection.room &&
              (() => {
                const coverImage = this.getRoomCoverImage(activeSelection.room.roomTypeId);
                return !!coverImage && (
                  <div className="room-cover-image">
                    <CoverImage imageId={coverImage.id} />
                  </div>
                );
              })()
            }
            {activeSelection.slot &&
              <CustomerProductList
                products={products}
                isLoading={productsIsFetching}
                pagination={pagination}
                setPage={setPage}
                showAll={showAll}
                onSelectProduct={v => this.orderVariant(activeSelection.slot, v)}
                onOpenProduct={openProduct}
                onRemoveProduct={() => removeOrderRow(activeSelection.orderRow.id, activeSelection.slot.id)}
                enabled={order.state === NEW && (!activeSelection.slot.advanced || !!activeSelection.canChoose)}
                activeSelection={activeSelection}
                userRole={userRole} />
            }
            {activeSelection.additional &&
              <CustomerCustomProductList
                customProducts={customRows} />
            }
          </div>
          {showActiveProduct && activeProduct && activeVariant && activeSelection.slot &&
            <CustomerProductDialog
              activeImage={activeImage}
              variant={activeVariant}
              product={activeProduct}
              onSelectProduct={v => this.orderVariant(activeSelection.slot, v)}
              onRemoveProduct={() => removeOrderRow(activeSelection.orderRow.id, activeSelection.slot.id)}
              onImageSelect={selectImage}
              onClose={closeProduct}
              enabled={order.state === NEW && (!activeSelection.slot.advanced || !!activeSelection.canChoose)}
              activeSelection={activeSelection}
              userRole={userRole} />
          }
        </div>
        {showHelp &&
          <ModalDialog
            onClose={() => toggleHelp(false)}
            showCloseButton={true}
            className="HelpFormDialog"
            show={true}>
            <HelpForm onSubmit={v => sendEmail(order.id, v.message)} />
          </ModalDialog>
        }
        <LoadingIndicator
          isGlobal={true}
          isLoading={productsIsFetching || roomsIsFetching || orderRowIsFetching} />
      </div>
    );
  }
}

const mapStateToProps = ({
  auth: {
    currentUser: {
      role: userRole,
    },
  },
  customerOrderView: {
    products: {
      list: products,
      isFetching: productsIsFetching,
    },
    product: {
      activeProduct,
      activeVariant,
      activeImage,
      show: showActiveProduct,
    },
    activeSelection,
    pagination,
    rooms: {
      expanded: expanedRooms,
      list: rooms,
      isFetching: roomsIsFetching,
    },
    orderRows: {
      bySlotId: orderRowBySlotId,
      isFetching: orderRowIsFetching,
    },
    customRows: {
      list: customRows,
    },
    prices: {
      open: pricesExpanded,
      roomPrices,
      additionalTotalPrice,
      total: totalPrice,
      discount,
    },
    menuVisibility: showMenu,
    orderComplete,
    help: showHelp,
  },
}: {auth: any, customerOrderView: CustomerOrderViewState}) => ({
  products,
  productsIsFetching,
  rooms,
  roomsIsFetching,
  customRows,
  activeProduct,
  activeVariant,
  activeImage,
  showActiveProduct,
  activeSelection,
  expanedRooms,
  pagination,
  orderRowBySlotId,
  orderRowIsFetching,
  roomPrices,
  additionalTotalPrice,
  totalPrice,
  discount,
  showMenu,
  userRole,
  orderComplete,
  showHelp,
  pricesExpanded,
});

const mapDispatchToProps = dispatch => ({
  fetchOrderData: (order, apartment) =>
    dispatch(fetchOrderData(order, apartment)),
  selectSlot: (orderId, room, slot) =>
    dispatch(selectSlot(orderId, room, slot)),
  setPage: page =>
    dispatch(setPage(page)),
  openProduct: (product, variant) =>
    dispatch(openProduct(product, variant)),
  closeProduct: () =>
    dispatch(closeProduct()),
  selectImage: image =>
    dispatch(selectImage(image)),
  toggleRoom: (room, expanded) =>
    dispatch(toggleRoom(room, expanded)),
  showAll: () =>
    dispatch(showAll()),
  createOrderRow: (orderId, slot, variant, config, parentConfig) =>
    dispatch(createOrderRow(orderId, slot, variant, config, parentConfig)),
  updateOrderRow: (row, slot, variant, config, parentConfig) =>
    dispatch(updateOrderRow(row, slot, variant, config, parentConfig)),
  removeOrderRow: (rowId, slotId) =>
    dispatch(removeOrderRow(rowId, slotId)),
  updateOrderRows: (rowId, data) =>
    dispatch(updateOrderRows(rowId, data)),
  toggleMenu: show =>
    dispatch(toggleMenu(show)),
  toggleHelp: show =>
    dispatch(toggleHelp(show)),
  sendEmail: (orderId, message) =>
    dispatch(sendEmail(orderId, message)),
  clear: () =>
    dispatch(clear()),
  selectAdvanced: (room, slot, productType) =>
    dispatch(selectAdvanced(room, slot, productType)),
  selectAdditional: () =>
    dispatch(selectAdditional()),
  clearOrderRows: rowId =>
    dispatch(clearOrderRows(rowId)),
  toggleRoomPrice: roomId =>
    dispatch(toggleRoomPrice(roomId)),
  toggleAdditionalPrice: () =>
    dispatch(toggleAdditionalPrice()),
  togglePrices: () =>
    dispatch(togglePrices()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerOrderContainer);



// WEBPACK FOOTER //
// ./src/containers/CustomerOrderContainer/CustomerOrderContainer.js